export type HistoryBatchInfo = {
  size: number;
  leadId: number;
};

type HistoryBatchRow = {
  id: number;
  batchId: string | null;
};

export function historyBatchInfo(rows: HistoryBatchRow[]): Map<string, HistoryBatchInfo> {
  const groups = new Map<string, HistoryBatchInfo>();
  rows.forEach((row) => {
    if (!row.batchId) return;
    const current = groups.get(row.batchId);
    groups.set(row.batchId, {
      size: (current?.size ?? 0) + 1,
      leadId: current ? Math.min(current.leadId, row.id) : row.id,
    });
  });
  return groups;
}

/** A stored batchId means this review was part of a group, even if filters hide the rest. */
export function canUndoGroup(row: { batchId: string | null }): boolean {
  return row.batchId !== null;
}
